import { RestaurantCardController as RestaurantCard } from './restaurantCardController/restaurantCard.controller';

export default RestaurantCard;
